import { Route, Routes } from 'react-router-dom'
import Error404 from '../../pages/Error404'
import AddCompanyDetails from './AddCompanyDetails'
import AdminAction from './AdminAction'
import AdminDashboard from './AdminDashboard'
import AllowingAccess from './AllowingAccess'
import BlockAccount from './BlockAccount'
import CompanyDetailsByAdmin from './CompanyDetailsByAdmin'
import CompanyValidation from './CompanyValidation'
import Contacts from './Contacts'
import GlobalSettings from './GlobalSettings'
import LinkedInPostComment from './LinkedInPostComment'
import Myprofile from './Myprofile'
import UserValidation from './UserValidation'
import MarketingPage from './MarketingPage'
import SocialMediaAutomation from './SocialMediaAutomation'

const AdminDashboardRoute = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<AdminDashboard />} />
                <Route path="*" element={<Error404 />} />
                <Route path="/user-validation" element={<UserValidation />} />
                <Route path="/admin-action" element={<AdminAction />} />
                <Route path='/company-validation' element={<CompanyValidation />} />
                <Route path='/block-account' element={<BlockAccount />} />
                <Route path='/add-company-details' element={<AddCompanyDetails />} />
                <Route path='/companyDetailsByAdmin' element={<CompanyDetailsByAdmin />} />
                <Route path='/my-profile' element={<Myprofile />} />
                <Route path='/contacts' element={<Contacts />} />
                <Route path='/allowing-access' element={<AllowingAccess />} />
                <Route path='/global-settings' element={<GlobalSettings />} />
                <Route path='/linkedin-post-comments' element={<LinkedInPostComment />} />
                <Route path='/marketing' element={<MarketingPage />} />
                <Route path='/socialMedia' element={<SocialMediaAutomation />} />
            </Routes>
        </div>
    )



}
export default AdminDashboardRoute;
